import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { Info } from "neetoicons";
import { Callout } from "neetoui";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";

import EmbedCode from "./EmbedCode";

const queryClient = new QueryClient();

const Main = props => {
  const { t } = useTranslation();

  const shouldRenderEmbedCode = window.globalProps.ssoEnabled;

  return shouldRenderEmbedCode ? (
    <QueryClientProvider client={queryClient}>
      <EmbedCode {...props} />
    </QueryClientProvider>
  ) : (
    <Callout icon={Info} style="info">
      {t("neetoMolecules.widget.developmentInfo")}
    </Callout>
  );
};

Main.propTypes = {
  /**
   * This specifies which is the primary widget which is shown on the left side of selection tabs.
   */
  primaryApp: PropTypes.string,
};

export default Main;
